import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { DeliveryDetailsService } from "../../_services/delivery-details.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastService } from "../../_services/toast.service";

@Component({
  selector: "app-delivery-details",
  templateUrl: "./delivery-details.component.html",
  styleUrls: ["./delivery-details.component.css"],
})
export class DeliveryDetailsComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private transport_token: string;
  private transport_status: string;
  private token_checking = true;
  private token_valid = false;
  private report_sent = false;

  constructor(
    private service: DeliveryDetailsService,
    private toast: ToastService,
    private route: ActivatedRoute
  ) {}

  private formError;
  private submitting = false;
  private planning = null;

  ngOnInit() {
    // Get the Params..
    this.route.queryParams.subscribe((params) => {
      this.transport_token = params["token"] || 1; // Get transport number Param
      this.transport_status = params["status"] || ""; // Get transport status Param
    });

    this.service.checkToken(this.transport_token).subscribe((response) => {
      if (response && response.id) {
        this.token_valid = true;
        this.planning = response;
        
        this.toast.success(
          this.planning.transporter.speaks_french
            ? "Identification transporteur réussie"
            : "Transporter identification success",
          false,
          this.planning.transporter.speaks_french
            ? "Accès sécurisé"
            : "Secured access"
        );
        if (this.transport_status) {
          // If status is provided, update the record and skip the form
          this.updateStatus(this.transport_status);
        }
      } else {
        this.toast.error(
          this.planning.transporter.speaks_french
            ? "Échec d'identification transporteur"
            : "Transporter identification error",
          false,
          this.planning.transporter.speaks_french
            ? "Accès sécurisé"
            : "Secured access"
        );
      }
      this.token_checking = false;
    });
  }

  form = new FormGroup({
    details: new FormControl("", [Validators.required]),
  });

  onSubmit() {
    this.service
      .submit({ form: this.form.value, transport_token: this.transport_token }) // Sublmit the details
      .subscribe((response) => {
        if (response && response.id) {
          this.report_sent = true; // If the response is an Object with an ID, this means a success
          this.toast.success(
            this.planning.transporter.speaks_french
              ? "Signalement réalisé avec succès"
              : "Report sent successfully",
            false,
            this.planning.transporter.speaks_french ? "Signalement" : "Report"
          );
        } else {
          this.toast.error(
            this.planning.transporter.speaks_french
              ? "Erreur lors du signalement"
              : "Error while sending report",
            false,
            this.planning.transporter.speaks_french ? "Signalement" : "Report"
          );
        }
        this.submitting = false; // Disable the loading button apparition
        this.form.enable(); // Re Enable the Form
        this.form.reset(); // Reset It
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }

  updateStatus(status: string) {
    this.service.updateStatus(this.transport_token, status).subscribe((response) => {
      if (response && response.id) {
        this.toast.success(
          this.planning.transporter.speaks_french
            ? "Statut mis à jour avec succès"
            : "Status updated successfully",
          false,
          this.planning.transporter.speaks_french ? "Mise à jour" : "Update"
        );
        this.report_sent = true;
        this.token_checking = false;
      } else {
        this.toast.error(
          this.planning.transporter.speaks_french
            ? "Erreur lors de la mise à jour du statut"
            : "Error while updating status",
          false,
          this.planning.transporter.speaks_french ? "Mise à jour" : "Update"
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/delivery-details/delivery-details.component.ts